<script lang="ts">
	export let className = 'size-5';
</script>

<!--
	Source: Figma
	Copyright: unknown
	Origin: Figma
-->

<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor" class={className}>
  <path d="M10.0003 17.4539C9.62859 17.4539 9.2797 17.3089 9.01692 17.0461L2.55415 10.5833C1.60359 9.63333 1.09137 8.37 1.11192 7.02611C1.13192 5.68278 1.68248 4.43555 2.66248 3.51333C4.5797 1.70722 7.7097 1.80889 9.64081 3.74L10.0008 4.1L10.3608 3.74C12.2919 1.80944 15.4225 1.70889 17.3391 3.51333C18.3186 4.43611 18.8691 5.68333 18.8897 7.02667C18.9103 8.37 18.398 9.63333 17.4475 10.5833L10.9841 17.0467C10.7219 17.3094 10.373 17.4539 10.0014 17.4539H10.0003ZM5.98081 3.88444C5.18526 3.88444 4.40415 4.16278 3.8047 4.72667C3.15637 5.33722 2.79137 6.16278 2.77803 7.05167C2.7647 7.94055 3.10359 8.77611 3.73192 9.405L9.9997 15.6728L16.2675 9.405C16.8958 8.77611 17.2347 7.94055 17.2214 7.05167C17.208 6.16333 16.8436 5.33778 16.1947 4.72667C14.9264 3.53278 12.8375 3.61889 11.5375 4.91833L10.5886 5.86722C10.263 6.19278 9.73581 6.19278 9.41026 5.86722L8.46137 4.91833C7.77526 4.23222 6.86915 3.88444 5.98026 3.88444H5.98081Z" />
</svg>
